import { FC, HTMLAttributes, ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';

import { Layout } from 'antd';
import cn from 'classnames';

import { AppDispatch } from 'app/appStore';
import { channelsApi } from 'entities/Channel';
//import { openOnboardingModal } from 'features/Onboarding';
import { useAppConfigRetrieveQuery } from 'shared/api';
import { ROUTES_WITHOUT_BOTTOM_BAR } from 'shared/consts';
import { useCommonSlice, useSendPageViewEvent } from 'shared/hooks';
import { EBaseApiTags } from 'shared/typings';
import { BottomBar, FrozenPopup } from 'shared/ui';
import { WebApp } from 'shared/utils';

import styles from './MainLayout.module.scss';

interface IMainLayoutProps extends HTMLAttributes<HTMLDivElement> {
	outlet?: ReactNode;
}

export const MainLayout: FC<IMainLayoutProps> = ({ className, outlet, ...props }) => {
	const { data: appConfig } = useAppConfigRetrieveQuery();
	const dispatch = useDispatch<AppDispatch>();
	const { pathname } = useLocation();
	const { isOpenFrozenPopup } = useCommonSlice();

	useSendPageViewEvent();

	const listener = () => {
		dispatch(channelsApi.util.invalidateTags([EBaseApiTags.CHANNELS]));
	};

	useEffect(() => {
		WebApp?.onEvent('activated', listener);

		return () => {
			WebApp?.offEvent('activated', listener);
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const withBottomBar = !ROUTES_WITHOUT_BOTTOM_BAR.some((route) => pathname.startsWith(route));

	useEffect(() => {
		if (!appConfig?.user) {
			return;
		}
		if (!appConfig.user?.balance) {
			//dispatch(openOnboardingModal());
		}
	}, [appConfig, dispatch]);

	return (
		<Layout
			{...props}
			className={cn(className, styles.layout)}
			style={{
				padding: `${WebApp?.safeAreaInset.top || 0}px ${WebApp?.safeAreaInset.right || 0}px ${(WebApp?.safeAreaInset.bottom || 0) + (withBottomBar ? 50 : 0)}px ${WebApp?.safeAreaInset.left || 0}px`,
			}}>
			{/*(isFetching || !appConfig?.user) && <OverlayLoader opacity={1} zIndex={101} />*/}
			<ScrollRestoration />
			<Layout.Content className={styles.content}>{outlet || <Outlet />}</Layout.Content>
			{withBottomBar && <BottomBar />}
			{isOpenFrozenPopup && <FrozenPopup />}
		</Layout>
	);
};
